var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{staticClass:"uk-input",attrs:{"rows":"5","type":"text","disabled":_vm.field.generated == true || (_vm.field.editable == false && !_vm.creating)},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }